import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import styled from 'styled-components';
import openedArrow from '../../../images/Autocode/arrow_opened.svg';

const CustomSelect = styled.div`
  width: 100%;
  height: 30px;
  padding-top: 5px;
  position: relative;
`;

const SelectLabel = styled.div`
  width: calc(100% - 30px);
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const ListBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: white;
  width: 100%;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding: 10px 0px;
`;

const ListItem = styled.button`
  padding: 5px 10px;
  margin-top: 5px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  &:nth-child(1) {
    margin-top: 0px;
  }
  &:hover {
    background-color: #f0f1f1;
  }
`;

const OnePlus = styled.span`
  background: #f4f4f4;
  border: 1px solid #848484;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 0px 10px;
`;

const PlusOneInput = styled.input`
  display: inline-flex;
  width: 33px;
  height: 18px;
  padding: 0px 5px;
  margin: 0px 5px;
  background: #f8fbff;
  border: 1px solid #94a2b7;
  box-sizing: border-box;
  border-radius: 3px;
  &:focus {
    background: #f8fbff;
    border: 1px solid #94a2b7;
    box-sizing: border-box;
    border-radius: 3px;
  }
`;

const Button = styled.button`
  width: 30px;
  position: absolute;
`;

const AutocodeDropdownV2 = ({
  selected,
  options,
  changeHandler,
  plusOneLabel = false,
  onePlusValue,
  setOnePlusValue,
  onBlurHandler,
  setOnePlusSelected,
  plusOneLabelText,
}) => {
  const [open, setOpen] = React.useState(false);
  const [otherSelect, setOtherSelect] = React.useState(false);
  const ref = React.useRef(null);

  const selectedLabel = options.find(o => o.value === selected).label;

  const handleOutsideClick = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener('mousedown', handleOutsideClick);
    return () => window.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const clickHandler = value => {
    if (value === 'Total Users 1+') {
      setOtherSelect(true);
      changeHandler(value);
      if (setOnePlusSelected) {
        setOnePlusSelected(true);
      }
      setOpen(false);
    } else {
      setOtherSelect(false);
      changeHandler(value);
      if (setOnePlusSelected) {
        setOnePlusSelected(false);
      }
      setOpen(false);
    }
  };

  const renderPlusOne = () => {
    return (
      <SelectLabel onClick={() => setOpen(!open)}>
        <span>Users</span>
        <PlusOneInput
          type="text"
          value={onePlusValue}
          onClick={e => e.stopPropagation()}
          onChange={e => setOnePlusValue(e.target.value)}
          onBlur={e => onBlurHandler(e.target.value)}
        />
        <span>in {plusOneLabelText}</span>
      </SelectLabel>
    );
  };

  return (
    <CustomSelect ref={ref} title={selectedLabel}>
      {otherSelect ? (
        renderPlusOne()
      ) : (
        <SelectLabel onClick={() => setOpen(!open)}>
          {selectedLabel}
        </SelectLabel>
      )}
      <Button type="button" onClick={() => setOpen(!open)}>
        <img
          className="autocode-label-selector"
          src={openedArrow}
          alt="label arrow"
        />
      </Button>
      {open && (
        <ListBox>
          {options.map(option => {
            if (plusOneLabel && option.value === 'Total Users 1+') {
              return (
                <ListItem
                  key={option.value}
                  onClick={() => clickHandler(option.value)}
                  title={option.label}
                >
                  Users <OnePlus>{onePlusValue}</OnePlus> in {plusOneLabelText}
                </ListItem>
              );
            }
            return (
              <ListItem
                key={option.value}
                onClick={() => clickHandler(option.value)}
                title={option.label}
              >
                {option.label}
              </ListItem>
            );
          })}
        </ListBox>
      )}
    </CustomSelect>
  );
};

AutocodeDropdownV2.propTypes = {
  selected: string,
  options: arrayOf(
    shape({
      value: string,
      label: string,
    })
  ),
  changeHandler: func,
  plusOneLabel: bool,
  onePlusValue: string,
  setOnePlusValue: func,
  onBlurHandler: func,
  setOnePlusSelected: func,
  plusOneLabelText: string,
};

export default AutocodeDropdownV2;
